import { fallback } from '@tanstack/zod-adapter';
import { z } from 'zod';

export const meilisearchSearchSchema = z.object({
  page: fallback(z.number(), 1).default(1),
  limit: fallback(z.number(), 10).default(10),
  filter: fallback(
    z.record(
      z.string(),
      z.object({
        value: z.union([
          z.string(),
          z.array(z.string()),
          z.array(z.array(z.string())),
          z.number(),
          z.boolean(),
          z.array(z.number()),
          z.array(z.boolean()),
        ]),
        operator: z.union([z.literal('custom'), z.literal('timerange')]).optional(),
      }),
    ),
    {},
  ).default({}),
  sort: fallback(z.array(z.string()), []).default([]),
  q: fallback(z.string(), '').default(''),
});
